import environment from "environment";
import {callServer} from "../utils/request-util";

export const getBillingPayment = () => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/payment",
            method: "GET",
            roles: [
                environment.USER_ROLES.supervisor,
            ]
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const deleteBillingPayment = (data) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/payment",
            method: "DELETE",
            data: data,
            roles: [
                environment.USER_ROLES.supervisor,
            ]
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const addBillingPayment = (data) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/payment",
            method: "POST",
            data: data,
            roles: [
                environment.USER_ROLES.supervisor,
            ]
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const getBillingAddresses = () => {
    // Internal model: ONE set of billing details per account (address + contact person +
    // billing email + phone) — not the legacy Recurly multi-address list.
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/address",
            method: "GET",
            roles: [
                environment.USER_ROLES.supervisor,
            ]
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const deleteBillingAddress = (id) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/address/" + id,
            method: "DELETE"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const addBillingAddress = (data) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/address",
            method: "POST",
            data
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const editBillingAddress = (shippingAddressId, data) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/address/"+ shippingAddressId,
            method: "PUT",
            data
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const setBillingAddress = (shippingAddressId) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/shippingAddressSet/" + shippingAddressId,
            method: "PUT"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getBillingInfo() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/baseInfo",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getBillingPlans() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/plans",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getBillingSetupIntent() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/setupIntent",
            method: "POST"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

// MASAV bank debit (הוראת קבע): availability + institution code + the saved account.
export function getBankDebit() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/bankDebit",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function setBankDebit(data) {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/bankDebit",
            method: "POST",
            data
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function disableBankDebit() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/bankDebit/disable",
            method: "POST"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function deleteBankAccount() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/bankDebit",
            method: "DELETE"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getBillingUsage() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/usage",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getBillingPaymentIntent(data) {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/paymentIntent",
            method: "POST",
            data
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function processBillingCard(token) {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/processCard",
            method: "POST",
            data: { token }
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getCurrentPlan() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/plan",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function previewPlanChange(planCode) {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/plan/preview",
            method: "POST",
            data: { planCode }
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getPlanActivationInfo() {
    // What activating the assigned plan means: onboarding-fee gate + the prorated
    // rest-of-month charge on forward-billed profiles.
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/plan/activation",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function activatePlan(data) {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/plan/activate",
            method: "POST",
            data: data || {}
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function setAccountPlan(data) {
    const payload = typeof data === "string" ? { planCode: data } : (data || {});

    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/plan",
            method: "POST",
            data: payload
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function payStatement(statementId, walletToken, cardId, intentToken, bankDebit, bankTransferTransactionId) {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/pay",
            method: "POST",
            // bankDebit is the merchant's EXPLICIT choice of the MASAV debit — the server
            // never picks a payment method on its own in manual payment.
            // bankTransferTransactionId confirms a hosted-fields bank transfer already made
            // in the browser — the server verifies it against Tranzila before marking paid.
            data: { statementId, walletToken, cardId, intentToken, bankDebit: !!bankDebit, bankTransferTransactionId }
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getWalletPaymentSession(validationUrl) {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/paymentSession",
            method: "POST",
            data: { validationUrl }
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getSmsPackages() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/sms/packages",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function purchaseSmsPackage(packageCode, walletToken, cardId, intentToken, purpose, bankTransferTransactionId) {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/sms/purchase",
            method: "POST",
            // purpose: 0 = OTP, 1 = Campaigns — separate provider users, the credit never mixes.
            // bankTransferTransactionId: a transfer completed in the browser; verified server-side.
            data: { packageCode, walletToken, cardId, intentToken, purpose: purpose || 0, bankTransferTransactionId }
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getSmsPurchases() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/sms/purchases",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getSmsBalances() {
    // UniCell balance per purpose user: { otp, campaigns } — null where unavailable.
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/sms/balances",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const getAccountCards = () => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/card",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const updateAccountCard = (cardId, card) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/card/" + cardId,
            method: "PUT",
            data: card,
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const billingCardAdd = (data) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/card",
            data,
            method: "POST"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const billingCardEdit = (billingInfoId, tokenId) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/card/" + billingInfoId + "/" + tokenId,
            method: "PUT"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const billingCardDelete = (cardId) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/card/" + cardId,
            method: "DELETE"
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export const invoicePdf = (invoiceId) => {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/invoice/" + invoiceId,
            method: "GET",
            responseType: "blob",
        }).then(response => resolve(response), error => reject(error.response));
    });
}

export function getBillingUsages() {
    return new Promise((resolve, reject) => {
        callServer({
            url: environment.backendAPI + "billing/usages",
            method: "GET"
        }).then(response => resolve(response), error => reject(error.response));
    });
}
